<template>
  <div class="text-icon-list">
    <div
      v-for="(icon_e,icon_k) in iconList"
      :key="icon_k"
      class="text-icon-list_content"
    >
      <TextIcon
        :text="icon_e.name"
        :icon="icon_e.icon"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "TextIconList",
  props: {
    iconList: {
      type: Array,
      default() {
        return [];
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/text-icon-list";
</style>